(() => {
  const selector = '[data-grow-review-link]';
  const reviews = '[data-grow-reviews]';
  const relevantSelector = selector + ',' + reviews;
  let refreshFrame;
  const visible = node => node.isConnected && node.getClientRects().length > 0 && getComputedStyle(node).visibility !== 'hidden' && !node.closest('[hidden],[aria-hidden="true"],[inert]');
  function automaticTarget(link) {
    return Array.from(document.querySelectorAll(reviews)).find(node => node.id && visible(node) && (link.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING));
  }
  function resolve(link) {
    if (link.dataset.growReviewMode === 'auto') {
      const target = automaticTarget(link);
      if (target) {
        const href = '#' + encodeURIComponent(target.id);
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        link.removeAttribute('aria-disabled');
      } else {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
      }
      return target;
    }
    try {
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return null;
      return document.getElementById(decodeURIComponent(url.hash.slice(1)));
    } catch { return null; }
  }
  function refresh() {
    refreshFrame = undefined;
    document.querySelectorAll(selector).forEach(link => {
      if (link.dataset.growReviewMode === 'auto') resolve(link);
    });
  }
  function queueRefresh() {
    if (refreshFrame === undefined) refreshFrame = requestAnimationFrame(refresh);
  }
  function relevantNode(node) {
    return node.nodeType === Node.ELEMENT_NODE && (node.matches(relevantSelector) || node.querySelector(relevantSelector));
  }
  function observeChanges(records) {
    const relevant = records.some(record => record.type === 'attributes' ? relevantNode(record.target) : Array.from(record.addedNodes).some(relevantNode) || Array.from(record.removedNodes).some(relevantNode));
    if (relevant) queueRefresh();
  }
  function focusTarget(target) {
    const heading = target.querySelector('[data-grow-reviews-heading]') || target;
    if (!(heading instanceof HTMLElement)) return;
    const temporary = !heading.hasAttribute('tabindex');
    if (temporary) {
      heading.setAttribute('tabindex', '-1');
      heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), { once: true });
    }
    heading.focus({ preventScroll: true });
  }
  function initialize() {
    refresh();
    const observer = new MutationObserver(observeChanges);
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-hidden', 'inert', 'class', 'style'] });
    document.addEventListener('click', event => {
      const link = event.target.closest?.(selector);
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = resolve(link);
      if (!target) {
        if (link.dataset.growReviewMode === 'auto') event.preventDefault();
        return;
      }
      event.preventDefault();
      const url = new URL(link.getAttribute('href'), location.href);
      if (location.hash !== url.hash) {
        try { history.pushState(history.state, '', url.hash); } catch {}
      }
      focusTarget(target);
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    });
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:block:select'].forEach(name => document.addEventListener(name, queueRefresh));
    window.addEventListener('resize', queueRefresh, { passive: true });
    window.addEventListener('pageshow', queueRefresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
